import { render } from "./PortfolioSection.vue?vue&type=template&id=96a218ea"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kojimakazuya/Projects/improver-corp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__